import { IPlanContent } from '../typings';
import { createPlanNameMatcher } from './utils/PlanMetaHelper';
import {
  defaultBusinessGasDetailsAddons,
  defaultEstimatesDialog,
  ongoingKeyDetails,
} from './common/planDefaults';

export const originBusinessUsageAdvantageOngoingContent: IPlanContent = {
  test: createPlanNameMatcher(['Origin Business Usage Advantage Ongoing']),
  content: {
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on an ongoing contract',
      },
    },
    keyFeatures: {
      defaultState: {
        defaultFuel: ['No lock in contract or exit fees'],
      },
    },
    keyDetails: {
      defaultState: {
        defaultFuel: ongoingKeyDetails,
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        dual: defaultBusinessGasDetailsAddons,
        gas: defaultBusinessGasDetailsAddons,
        electricity: [],
      },
    },
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'blue',
              odsCore: 'promote',
            },
            promobox: {
              styleGuide: 'blue',
              odsCore: 'promote',
            },
            bannerText: {
              styleGuide: 'white',
              odsCore: 'white',
            },
          },
          imageUrl:
            'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/pictograms/pictogram_rates-variable.svg',
        },
      },
    },
    tagLine: {
      defaultState: {
        defaultFuel: 'Designed for high energy use businesses. Variable usage and supply rates.',
      },
    },
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions/business-usage-advantage-ongoing/',
      },
    },
    estimatesDialog: defaultEstimatesDialog({ customerType: 'business' }),
  },
};
